import { Column, IconButton, Row } from 'components/Blocks';
import { FileUpIcon, XIcon } from 'components/Icons';

import { fixFileName, truncateText } from 'utils/text';

export type CommentInputFile = {
  file: File;
  url: string;
};

interface CommentFilesProps {
  files: CommentInputFile[];
  removeFile: (index: number) => void;
}

export function CommentInputFiles({ files, removeFile }: CommentFilesProps) {
  return (
    <Column gap="1" className="pt-2">
      <Row flexWrap="wrap" gap="2">
        {files.map(({ file, url }, index) => (
          <div key={file.lastModified} className="group relative size-20 rounded-lg border">
            {file.type.startsWith('image/') ? (
              <img src={url} alt="" className="size-full rounded-lg object-cover" />
            ) : (
              <Column
                gap="1"
                alignItems="center"
                justifyContent="center"
                className="size-full overflow-hidden"
              >
                <FileUpIcon />

                <span className="text-ellipsis px-1 text-center text-xxs" title={file.name}>
                  {truncateText(fixFileName(file.name), 15)}
                </span>
              </Column>
            )}

            <IconButton
              color="destructive"
              variant="filled"
              size="small"
              className="absolute -right-2 -top-2 hidden p-0.5 text-destructive-foreground group-hover:block phone:block"
              onClick={() => removeFile(index)}
            >
              <XIcon size={12} />
            </IconButton>
          </div>
        ))}
      </Row>

      <span className="muted pl-1 text-xxs">Up to 5 files</span>
    </Column>
  );
}
